var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiEnabledScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8376 2.125C31.1406 2.125 30.4806 2.26538 29.8538 2.47363C33.4578 3.48301 36.125 6.76036 36.125 10.6831V23.375H40.4165C43.9079 23.375 46.75 20.5309 46.75 17.0374V8.46265C46.75 4.96915 43.9079 2.125 40.4165 2.125H31.8376ZM8.36304 6.375C5.98516 6.375 4.05078 8.30736 4.05078 10.6831V44.5669C4.05078 46.9426 5.98516 48.875 8.36304 48.875H27.5669C29.9426 48.875 31.875 46.9426 31.875 44.5669V10.6831C31.875 8.30736 29.9426 6.375 27.5669 6.375H8.36304ZM8.36304 10.625L12.0071 10.6375L13.248 13.1194C13.554 13.7378 14.1844 14.1279 14.875 14.1279H21.2002C21.8908 14.1279 22.519 13.7378 22.8272 13.1194L24.0515 10.6748L27.625 10.6831V44.5669C27.625 44.5988 27.5988 44.625 27.5669 44.625L8.30078 44.5669L8.36304 10.625ZM10.625 21.25V27.625H14.875V25.5H17V21.25H10.625ZM19.125 21.25V25.5H21.25V27.625H25.5V21.25H19.125ZM10.625 29.75V36.125H17V31.875H14.875V29.75H10.625ZM21.25 29.75V31.875H19.125V36.125H25.5V29.75H21.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEnabledScan);
export default __webpack_public_path__ + "static/media/ai-enabled-scan.00939e30cf34125f0d9673f171d5cc5c.svg";
export { ForwardRef as ReactComponent };